import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "80",
  height: "80",
  viewBox: "0 0 12.869 9.192"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "rgb(255,255,255)",
  d: "M6.435 6.435A1.838 1.838 0 1 1 8.273 4.6a1.839 1.839 0 0 1-1.838 1.835zm0-6.435C1.838 0 0 4.6 0 4.6s1.838 4.6 6.435 4.6 6.435-4.6 6.435-4.6S11.031 0 6.435 0z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };